export function nodelistToArray (nodeList) {
  return [].slice.call(nodeList)
}



// WEBPACK FOOTER //
// ./src/client/helpers/nodelistToArray.js